import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import eeeFacultyData from "./facultyData/eeeFacultyData";

const facultyOrder = [
  "f-v-a-kulkarni",
  "f-manjunatha",
  "f-rajeshwari-nanannavar",
  "f-arun-l-kakhandki",
  "f-prakash-laxman-chavan",
  "f-vijay-bagewadi",
  "f-sheetal-n-mindolkar",
  "f-subrahmanya-hegde",
  "f-varaprasad-gaonkar",
  "f-ravindra-motekar",
  "f-kirankumar-hittanagi",
];

const getOrderedFacultyMembers = (members = []) => [
  ...facultyOrder
    .map((id) => members.find((faculty) => faculty.id === id))
    .filter(Boolean),
  ...members.filter((faculty) => !facultyOrder.includes(faculty.id)),
];

const facultyData = {
  ...eeeFacultyData,
  hod: eeeFacultyData.hod,
  members: getOrderedFacultyMembers([
    eeeFacultyData.hod,
    ...eeeFacultyData.members,
  ]),
};

export const programme = {
  id: "eee",
  name: "Electrical & Electronics Engineering",
  short: "EEE",
  programmeType: "ug",
  duration: "4 Years (8 Semesters)",
  intake: 60,
  // studentsEnrolled: 240,
  // facultyStrength: 8,
  // phdFaculty: 1,
  established: 2004,
  description: "The Department of Electrical & Electronics Engineering was established in 2004 and offers a B.E. programme that provides a strong foundation in power systems, electrical machines, control engineering, power electronics, and renewable energy systems. The department prepares engineers to contribute to India's evolving energy sector through outcome-based education, modern laboratories, and strong industry collaborations.",
  image: "/HomePage/dept/eee.jpeg",
  hodId: "f-rajeshwari-nanannavar",
  facultyData,
  showHodInFacultyList: true,
  labs: ["Power Systems Lab", "Electrical Machines Lab", "Control Systems Lab", "Power Electronics Laboratory"],
  research: "Smart Grids · Power Electronics · Renewable Energy · Power Systems",
  accreditation: [ "AICTE Approved Intake: 60 seats", "MoU with KREDL for joint research"],
  achievements: [
    {
      title: "Achievement Documents",
      items: [

        {
          label: "Appreciation Letter",
          href: "/Achievements/EEE/AppreciationLetter.jpg"
        },

      ],
    },
  ],
  projects: [
    { title: "Hybrid Solar-Wind Microgrid for Western Ghats", funding: "MNRE", amount: "Rs. 22 L" },
    { title: "EV Charging Infrastructure Study", funding: "KREDL", amount: "Rs. 7 L" },
  ],
  dashboard: [
    ["Faculty Members", "11"],
    ["Faculty with Ph.D.", "02"],
    ["Faculty pursuing Ph.D", "07"],
    ["Laboratories", "06"],
  ],
  academicVision:
    "To foster the technical skills, research & innovation in the young minds and enabling 	them by reinforcing the contemporary needs with sustained societal development in 	the field of Electrical & Electronics Engineering.",
  academicOverview: [
    {
      title: "Academic Strengths",
      text: "The department is committed to academic excellence through qualified and experienced faculty, modern laboratory infrastructure, and outcome-based education. Strong industry collaborations and research initiatives support effective learning and skill development in core electrical engineering domains.",
    },
    {
      title: "Mission",
      text: [
        "To imbibe innovative pedagogy to impart technical knowledge among the students in the field of Electrical and Electronics Engineering.",
        "To create a passion for learning, promote innovation and entrepreneurship.",
        "To develop strong collaboration with premier industries, government agencies, and professional bodies.",
        "To instil moral and ethical values among stakeholders.",
      ],
    },
    {
      title: "Beyond Syllabus",
      text: "The department provides experiential learning through industrial visits, hands-on training in PLC, SCADA, renewable energy systems, electrical design and simulation tools, research and innovation projects, industry internships, expert lectures, entrepreneurship initiatives, professional society activities, technical competitions, and multidisciplinary project development, enhancing problem-solving, leadership, and industry-readiness skills.",
    },
  ],
  curriculumSupport: [
    "Laboratory sessions provide hands-on experience in power systems, electrical machines, control systems, and renewable energy.",
    "Project-based learning enables students to apply theoretical knowledge to real-world electrical engineering problems.",
    "Internship opportunities help students gain exposure to the energy sector and power industry.",
    "Regular workshops and seminars keep students updated with advancements in smart grids, EVs, and renewable energy.",
    "Value-added courses and NPTEL certification programs enhance technical skills beyond the university curriculum.",
    "Industry interactions with KREDL, MNRE, and other bodies bridge academic learning with industry requirements.",
    "Soft skills and employability training develop communication, leadership, and career readiness.",
    "Continuous mentoring and academic guidance support students' overall professional growth.",
  ],
  programmeOutcomes: [
    "Engineering knowledge: Apply the knowledge of mathematics, science, engineering fundamentals, and an engineering specialization to the solution of complex engineering problems.",
    "Problem analysis: Identify, formulate, review research literature, and analyze complex engineering problems reaching substantiated conclusions using the first principles of mathematics, natural sciences, and engineering sciences.",
    "Design/development of solutions: Design solutions for complex engineering problems and design system components or processes that meet the specified needs with appropriate consideration for public health and safety and cultural, societal, and environmental considerations.",
    "Conduct investigations of complex problems: Use research-based knowledge and research methods including design of experiments, analysis, interpretation of data, and synthesis of the information to provide valid conclusions.",
    "The engineer and society: Apply to reason informed by the contextual knowledge to assess societal, health, safety, legal and cultural issues and the consequent responsibilities relevant to the professional engineering practice.",
    "Environment and sustainability: Understand the impact of professional engineering solutions in societal and environmental contexts and demonstrate the knowledge of and need for sustainable development.",
    "Ethics: Apply ethical principles and commit to professional ethics and responsibilities and norms of the engineering practice.",
    "Individual and team work: Function effectively as an individual and as a member or leader in diverse teams and in multidisciplinary settings.",
    "Communication: Communicate effectively on complex engineering activities with the engineering community and with society at large, such as being able to comprehend and write effective reports and design documentation, make effective presentations and give and receive clear instructions.",
    "Project management and finance: Demonstrate knowledge and understanding of the engineering and management principles and apply these to one’s own work, as a member and leader in a team, to manage projects and in multidisciplinary environments.",
    "Recognize the need for lifelong learning and adapt to technological changes in mechanical engineering and allied fields.",
  ],
  pso: [
    "Apply knowledge of electrical engineering principles to analyze, design, and implement power systems, electrical machines, and electronic circuits for practical applications.",
    "Apply knowledge of renewable energy systems and power electronics to design sustainable and efficient energy solutions.",
  ],
  peo: [
    "Develop an ability to identify and analyze electrical engineering problems and provide innovative engineering solutions for the energy sector.",
    "Develop abilities to work in teams on multidisciplinary projects with effective communication skills, ethical qualities, and leadership roles.",
    "Develop abilities for successful Electrical Engineering careers and achieve higher academic and professional goals.",
  ],
  studentActivities: {
    clubs: [
      {
        name: "Electra",
        category: "Student Club",
        description:
          "Electra supports student-led activities, technical discussions, and peer learning in the EEE department.",
        reports: [
          { title: "Alumni Engagement Program,", href: "/student-club/EE&E/ELECTRA/activity-1.pdf" },
          { title: "Kadra Hydropower Plant Visit", href: "/student-club/EE&E/ELECTRA/kadra.pdf" },
        ],
      },
    ],
    // professionalChapters: ["IEEE", "ISTE", "IEI", "KREDL Energy Cell"],
  },
  newsEvents: {
    reports: [
      { label: "Energy Conservation Awareness Program", href: "/EVENTS/EE&E/energy-conservation-awareness-program.pdf" },
      { label: "Beyond Classroom Workshop", href: "/EVENTS/EE&E/beyond-classroom-workshop.pdf" },
    ],
  },
  facultyTable: [
    ["Dr. V. A. Kulkarni", "Ph.D.", "30 years"],
    ["Mr. Manjunatha", "BE, M.Tech, M.Tech.", "28 years"],
    ["Mrs. Rajeshwari Nanannavar", "BE, M.Tech, M.Tech.", "14 years"],
    ["Dr. Arun L. Kakhandki", "BE, M.Tech, Ph.D", "30 years"],
    ["Prof. Prakash Laxman Chavan", "BE, M.Tech, M.Tech.", "15 years"],
    ["Mr. Vijay Bagewadi", "To be updated", "To be updated"],
    ["Mrs. Sheetal N. Mindolkar", "BE, M.Tech, M.Tech.", "3 years"],
    ["Mr. Subrahmanya Hegde", "BE, M.Tech", "13 years"],
    ["Mr. Varaprasad Gaonkar", "BE, M.Tech, M.Tech.", "14 years"],
    ["Mr. Ravindra Motekar", "BE, M.Tech, M.Tech.", "10 years"],
    ["Mr. Kirankumar Hittanagi", "BE, M.Tech, M.Tech.", "10 years"],
  ],
  teachingStaff: [
    ["Dr. V. A. Kulkarni", "Professor & Principal"],
    ["Mr. Manjunatha", "Assistant Professor & Dean (Admin)"],
    ["Mrs. Rajeshwari Nanannavar", "Assistant Professor & Head"],
    ["Dr. Arun L. Kakhandki", "Professor"],
    ["Mr. Prakash Laxman Chavan", "Assistant Professor"],
    ["Mr. Vijay Bagewadi", "Assistant Professor"],
    ["Mrs. Sheetal N. Mindolkar", "Assistant Professor"],
    ["Mr. Subrahmanya Hegde", "Assistant Professor"],
    ["Mr. Varaprasad Gaonkar", "Assistant Professor"],
    ["Mr. Ravindra Motekar", "Assistant Professor"],
    ["Mr. Kirankumar Hittanagi", "Assistant Professor"],
  ],
  nonTeachingStaff: [
    ["Mr. Shashishekhar B.", "Foreman"],
    ["Mr. Rameshwar Naik", "Instructor"],
    ["Mr. Mahabaleshwar S. P.", "Instructor"],
    ["Mr. Vittal Karanjolkar", "Asst. Instructor"],
    ["Mr. Prasad Dhanayat", "Mechanic"],
    ["Mr. Baburao Seemani", "Mechanic"],
    ["Mr. Pavan Bandodkar", "Mechanic"],
    ["Mr. Namadev N. Pagoj", "Attender"],
    ["Mr. Satish Chalwadi", "Helper"],
  ],
};

const EEE = () => <ProgrammeDetail programme={programme} />;

export default EEE;
